export var UnifiedAlertsPageSubjects;
(function (UnifiedAlertsPageSubjects) {
    UnifiedAlertsPageSubjects["Page"] = "unified-alerts-page";
    UnifiedAlertsPageSubjects["FormPage"] = "unified-alerts-form-page";
    UnifiedAlertsPageSubjects["ConfigurationTable"] = "unified-alerts-configuration-table";
    UnifiedAlertsPageSubjects["StatusTable"] = "unified-alerts-status-table";
    UnifiedAlertsPageSubjects["ActionsMenu"] = "unified-alerts-actions-menu";
    UnifiedAlertsPageSubjects["EmptyState"] = "unified-alerts-empty-state";
    UnifiedAlertsPageSubjects["ErrorState"] = "unified-alerts-error-state";
    UnifiedAlertsPageSubjects["AlertTitleInput"] = "unified-alerts-title-input";
})(UnifiedAlertsPageSubjects || (UnifiedAlertsPageSubjects = {}));
export var UnifiedAlertSourceType;
(function (UnifiedAlertSourceType) {
    UnifiedAlertSourceType["Logs"] = "LOG_ALERT";
    UnifiedAlertSourceType["Metrics"] = "METRIC_ALERT";
})(UnifiedAlertSourceType || (UnifiedAlertSourceType = {}));
export var UnifiedAlertEventsState;
(function (UnifiedAlertEventsState) {
    UnifiedAlertEventsState["Triggered"] = "TRIGGERED";
    UnifiedAlertEventsState["Resolved"] = "RESOLVED";
    UnifiedAlertEventsState["Pending"] = "PENDING";
    UnifiedAlertEventsState["NoData"] = "NO_DATA";
    UnifiedAlertEventsState["Unknown"] = "UNKNOWN";
})(UnifiedAlertEventsState || (UnifiedAlertEventsState = {}));
//# sourceMappingURL=unified-alerts.enum.js.map